import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// 门户/菜单/顶栏大量使用 fa-*，与 public-financial 一致显式引入（heyui 不带 FA）
import 'font-awesome/css/font-awesome.css';
import './styles/zhuxi-ui-tokens.css';
import './styles/app.less';
import StdPagination from './components/StdPagination.vue';
import Tag from './components/Tag.vue';
import UserPicker from './components/UserPicker.vue';
import CompanyTreePicker from './components/CompanyTreePicker.vue';
import zhCn from 'heyui/dist/locale/zh-CN';
import ZxDate from './components/ZxDate.vue';

Vue.use(HeyUI, { locale: (zhCn && zhCn.default) ? zhCn.default : zhCn });
// 显式固定日期格式（与后端/查询参数一致，数字串）
if (typeof HeyUI !== 'undefined' && HeyUI.config) {
	HeyUI.config('datepicker.format', {
		date: 'YYYY-MM-DD',
		month: 'YYYY-MM',
		year: 'YYYY',
		time: 'HH:mm',
		datetime: 'YYYY-MM-DD HH:mm',
		datehour: 'YYYY-MM-DD HH:mm',
		datetimesecond: 'YYYY-MM-DD HH:mm:ss'
	});
}
// HeyUI $Confirm 默认贴顶(middle:false)；统一垂直居中（与 org-auth 一致）
function __zxEnableConfirmMiddle() {
	const api = (typeof HeyUI !== 'undefined' && HeyUI && HeyUI.$Confirm)
		|| (Vue.prototype && Vue.prototype.$Confirm);
	if (api && typeof api.config === 'function') {
		api.config({ middle: true });
	}
}
__zxEnableConfirmMiddle();

// 统一分页组件，全局注册后各页面可直接 <StdPagination> 使用
Vue.component('StdPagination', StdPagination);
// 轻量 Tag 组件（本版 HeyUI 无独立 Tag），全局注册后 <Tag color="..."> 直接生效
Vue.component('Tag', Tag);
// 远程用户选择器（HeyUI 的 Select/AutoComplete 仅前端过滤、无法远程取数），输入姓名/手机号按关键字匹配
Vue.component('UserPicker', UserPicker);
// 归属公司树选（下拉面板；仅 COMPANY 可选）
Vue.component('CompanyTreePicker', CompanyTreePicker);
Vue.component('ZxDate', ZxDate);
Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
